import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-lavender px-5 py-12 sm:py-20" data-id="element-43" data-mp="1hduloasc2p61">
      <div className="mx-auto max-w-2xl" data-id="element-44" data-mp="1cfjanwqay8m8">
        <h2 className="text-center font-serif-display text-2xl font-bold text-plum sm:text-4xl" data-id="element-45" data-mp="1ccdpgsksnqvs">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-46" data-mp="252vz6cg0wqi6">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className={`overflow-hidden rounded-2xl border bg-card transition-colors duration-200 ease-out ${isOpen ? 'border-gold/50' : 'border-aura/15'}`} data-id="element-47" data-mp="202rgcfrn7jos" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-48" data-mp="op5qsthvfg2q">
                  <span className="text-sm font-semibold leading-snug text-plum sm:text-base" data-id="element-49" data-mp="1kngrxs83n6vo">
                    {faq.question}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-aura/10 text-aura" data-id="element-50" data-mp="1pkgz66goqfod">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="1fo43j31kxrqz" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="1fqqc9607idas" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-53" data-mp="16nywwv47mxdv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-54" data-mp="16picsklyf6f4">
                      <p className="border-t border-gold/25 px-5 pb-4 pt-4 text-sm leading-relaxed text-plum/75" data-id="element-55" data-mp="n22lww0loxqd">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <p className="mt-8 text-center text-xs leading-relaxed text-plum/70 sm:text-sm" data-id="element-56" data-mp="2fxd9m7ufnx7t">
          Aura Viva 2026 es un recurso digital de bienestar y autocuidado. No realiza diagnósticos,
          no reemplaza atención médica o psicológica y no constituye un tratamiento.
        </p>
      </div>
    </section>;
}